import React from "react";
import "./Feedback.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as FEEDBACK } from "../../../assets/images/Feedback.svg";

const Feedback = (props) => {
  const { t } = useTranslation();

  const handleClick = () => {
    window.Userback.open();
    if (props.onClick) {
      props.onClick();
    }
  }
  return (
    <div
      className="feedback-button-container"
      onClick={handleClick}
    >
      <div
        className="feedback-button"
      >
        <FEEDBACK />
        {t("footer.feedback_text")}
        <i className="fa fa-angle-right" aria-hidden="true"></i>
      </div>
    </div>
  );
};

export default Feedback;
